export default __webpack_public_path__ + "static/media/OfficeAssistant.5c3fbb95.png";